import { useState } from "react";

const RecursiveMenu = ({ menuItems = [], handleNavigate }) => {
  const [openItems, setOpenItems] = useState({});

  const handleToggle = (index) => {
    setOpenItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <ul className="w-full flex flex-col space-y-3">
      {Array.isArray(menuItems) && menuItems.map((item, index) => (
        <li key={index} className="w-full">
          <div
            onClick={() => (item.subMenu ? handleToggle(index) : handleNavigate?.(item.path))}
            className={`flex flex-row justify-start items-center rounded-r-lg px-2 cursor-pointer h-10 hover:bg-secondary dark:hover:text-black 
              ${openItems[index] ? "border-l-4 border-blue-500" : ""}`}
          >
            {item.svg}
            <span className="w-36 text-sm">{item.label}</span>
          </div>
          {item.subMenu && openItems[index] && (
            <div className="pl-4">
              <RecursiveMenu menuItems={item.subMenu} handleNavigate={handleNavigate} />
            </div>
          )}
        </li>
      ))}
    </ul>
  );
};

export default RecursiveMenu;
